module.exports = __webpack_public_path__ + "Step3_Header_new.dd54d422.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Step3_Header_new.png
// module id = Uiny
// module chunks = 0